export default {"src":"/_next/static/media/mock_mobile_order.a18b5990.svg","height":89,"width":324,"blurWidth":0,"blurHeight":0};